<template>
    <div id='fixFootWrap' class='fixPt3'>
        <div class='in'>
            <!-- 주문이 불가능한 경우 -->
            <div v-if='!alive || !ableOrderFlag' class='fixOpenWrap'>
                <FooterMsgForStore/>
            </div>
            <div v-else-if="typeof openAreaDeliveryAble !== 'undefined' && !openAreaDeliveryAble" class='fixOpenWrap'>
              <div class='row'>
                <div class='col'>
                  <p class='tit'>주문 가능 지역이 아닙니다.</p>
                  <ul class='ul'><li><span>주소를 다시 확인해주세요</span></li></ul>
                </div>
              </div>
            </div>
            <div v-else class='favMenuWrap'>
                <!-- alert for adding menu in cart -->
                <div class='favGuideTxt'>
                    <div class='row'><div class='col'>{{$t('menuHasBeenAddedToCart')}}</div></div>
                </div>
                <!-- history -->
                <div v-if='histories && histories.length > 0 && showHistoryFlag' class='favMenuBox'>
                    <div class='toggTit'>
                        <button type='button' class='toggBtn'>
                            <span class='ico'></span><span>{{companyType == 5 ? $t('shoppingFrequentlyOrdered') : $t('frequentlyOrdered')}}</span>
                        </button>
                    </div>
                    <!-- history menu list -->
                    <div class='toggCnt'>
                        <div class='box'>
                            <a v-for='history in histories' :key='history.code' class='tag favMenuIcon' @click='moveToMenuDetail(history)'>
                                {{history.name}}
                            </a>
                        </div>
                    </div>
                    <!-- close button for history view -->
                    <button class='close' type='button' @click='hideHistoryContainer'>
                        <span class='ico'>닫기</span>
                    </button>
                </div>
                <!-- information of cart -->
                <div v-if='cartMenuNo > 0' class='cartWrap row' @click='$emit("showCart")'>
                    <div class='col col1'>
                        <button type='button' class='btn cart'>
                            <em class='ico'></em><em class='num'>{{cartMenuNo}}</em>
                        </button>
                    </div>
                    <div class='col col3'>
                        <span class='sum'>
                            <em class='num'>{{appFlag ? formatComma(appTotalPrice) : formatComma(totalPrice)}}</em><em class='won'>{{$t('MoneyUnit')}}</em>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="js">
import FooterMsgForStore from '@/components/Footer/FooterMsgForStore.vue'
import { MAIN_FOOTER } from '@/utils/EndPoint'
import { THROW_MENU } from '@/router'
import { SET_HISTORY_FLAG_FALSE } from '@/store/_actions/actionTypes'
import Vue from 'vue'
export default Vue.extend({
  name: MAIN_FOOTER,
  props: ['companyType', 'cartInfo', 'appTotalPrice'],
  components: { FooterMsgForStore },
  data () {
    return {
      addCartFlag: this.$route.params.addCartFlag,
      alive: this.$store.getters.alive // pos on/off
    }
  },
  computed: {
    // 카트에서 개수와 가격이 변할 수 있으므로, computed에서 관리
    cartMenuNo () {
      if (this.appFlag) {
        return this.cartInfo.length
      } else {
        return this.$store.getters.cartMenuNo
      }
    },
    histories () { return this.$store.getters.myHistoryMenu },
    // history show flag
    showHistoryFlag () { return this.$store.getters.showHistoryFlag },
    ableOrderFlag () { return this.$store.getters.ableOrderFlag }, // 주문가능여부
    totalPrice () { return this.$store.getters.totalPrice },
    openAreaDeliveryAble () {
      return this.$store.getters.openAreaDeliveryAble
    }
  },
  mounted () {
    // 카트에 상품이 추가된 경우에는 alert 문구 보여주기
    if (this.addCartFlag) {
      this.showAddCartAlert(this.setHistoryItem)
    }
    // 자주 이용해요 '...' 처리
    if (this.histories && this.histories.length > 0) {
      this.setHistoryItem()
    }
    // add padding for company information
    this.setFooterHeight()
  },
  updated () {
    // 자주 이용해요 '...' 처리
    if (this.histories && this.histories.length > 0) {
      this.setHistoryItem()
    }
    // add padding for company information
    this.setFooterHeight()
  },
  beforeDestroy () { this.removeDim() },
  methods: {
    moveToMenuDetail (history) { // 상품 상세 페이지로 이동
      THROW_MENU(history.code)
    },
    hideHistoryContainer () { // 자주 이용해요 container 제거
      this.$store.dispatch(SET_HISTORY_FLAG_FALSE)
    }
  }
})
</script>
